export default "__VITE_ASSET__DnyTmIzm__"